import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Product } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class ProductService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getProduct(id): Promise<Product> {
    return new Product(
      await this.core.services.product.getById(id, {
        // todo
        id: null,
      })
    )
  }

  // async getProducts(
  //   // todo
  //   parameters: any = {
  //     page: 1,
  //     sort: 'id',
  //     direction: 'asc',
  //   },
  //   schema: any = { id: null }
  // ): Promise<{
  //   items: Product[]
  //   paginator: { current: null; endPage: null; totalCount: null }
  // }> {
  //   const a = await this.core.services.product.getList(parameters, schema)
  //   console.log(a)
  //   return a
  //   // return await this.core.services.product.getList(parameters, schema)
  // }

  async getProducts(
    // todo
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
    },
    schema: any = { id: null }
  ): Promise<any> {
    return await this.core.services.product.getList(parameters, schema)
  }

  // createCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {
  //     return this.core.services.checkout.createWithTanstack(checkout, schema)
  // }

  // updateCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {y
  //     return this.core.services.checkout.updateWithTanstack(checkout, schema)
  // }

  // deleteOrder(order: Partial<Order>): Promise<Order> {todo
  //   return this.core.services.order.dele(Order)
  // }
}
